import { connect } from 'react-redux';
import { denormalize } from 'normalizr';
import { schema } from '../../../../../state/schema';

import OnboardingScreen from '../components/OnboardingScreen';
import { loadCognitoFormAnswerOnboarding } from '../../../../../state/modules/cognitoFormAnswers/actions';
import storage from '../../../../../lib/Storage';
import { findStorageType } from '../../../../../lib/Auth';

const mapStateToProps = (state, ownProps) => {
  const careGuideId = ownProps.careGuideId;
  const partnershipId = storage.get(findStorageType(), 'partnershipId');

  const cognitoFormAnswerId = state.cognitoFormAnswers.getIn([
    'cognitoFormAnswer',
    partnershipId,
    careGuideId,
  ]);

  const cognitoFormAnswer = cognitoFormAnswerId
    ? denormalize(
        state.entities.getIn(['cognitoFormAnswers', cognitoFormAnswerId]),
        schema.cognitoFormAnswer,
        state.entities.toJS()
      )
    : null;

  return {
    cognitoFormAnswer,
    partnershipId,
    careGuideId,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    load: (partnershipId, careGuideId, cb) => {
      dispatch(loadCognitoFormAnswerOnboarding(partnershipId, careGuideId, cb));
    },
  };
};

const OnboardingScreenContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(OnboardingScreen);

export default OnboardingScreenContainer;
